/* eslint-disable global-require, flowtype/require-valid-file-annotation, no-console */
/* @flow */
const Immutable = require('immutable');

module.exports = function exposeGlobals(root: Object, other: Object) {
  // Expose anything else passed in on the window. Namely the redux store
  Object.assign(root, other);

  // NOTE: This was not named "d3" because i wanted to avoid accidentally
  // missing errors related to removing the d3 package since they would be
  // picked up in dev by the global d3 but not in prod
  root._d3 = Object.assign(
    {},
    require('d3-drag'),
    require('d3-zoom'),
    require('d3-force'),
    require('d3-scale'),
    require('d3-ease'),
    require('d3-selection'),
    require('d3-transition'),
    require('d3-array'),
    require('d3-brush'),
    require('d3-time'),
    require('d3-format'),
    require('d3-time-format'),
    require('d3-shape')
  );
  root.transit = require('transit-immutable-js');
  root.reactStringReplace = require('react-string-replace');
  root.R = require('ramda');
  root.dateFns = require('date-fns');
  root.moment = require('moment');
  root.ReduxForm = require('redux-form/immutable');
  root.ms = require('ms');
  root.Rx = require('rxjs');
  root.Obs = root.Rx.Observable;
  root.bowser = require('bowser');
  root.escapeRegExp = require('lodash.escaperegexp');
  root.storage = require('trustar/utils/storage.js');
  root.trutils = require('trustar/utils/utils.js');
  root.createTween = require('trustar/utils/createTween.js').default;
  root.trustar = {
    fp: require('trustar/fp'),
    utils: Object.assign(
      {},
      require('trustar/utils'),
      require('trustar/utils/utils.js')
    ),
    graphUtils: require('trustar/constellation/graph-utils.js')
  };
  // Useful for debugging state/prop updates within components
  root.diff = root.trustar.utils.diff;

  root.App = require('./modules/app');
  root.Alerts = require('./modules/alerts');
  root.Analysis = require('./modules/analysis');
  root.Reports = require('./modules/reports');
  root.Display = require('./modules/display');
  root.Profile = require('./modules/profile');
  root.GlobalWhitelist = require('./modules/global-whitelist');
  root.CompanyWhitelist = require('./modules/company-whitelist');
  root.Search = require('./modules/search');
  root.Create = require('./modules/create');
  root.DevTasks = require('./modules/devtasks');
  root.Enclave = require('./modules/enclave');
  root.EnclaveManagement = require('./modules/enclave-management');
  root.Icons = require('./modules/icons');
  root.Templates = require('./modules/templates');
  root.Marketplace = require('./modules/marketplace');
  root.SubscriptionManagement = require('./modules/subscription-management');
  root.Subscriptions = require('./modules/subscriptions');
  root.Redaction = require('./modules/redaction');
  root.Companies = require('./modules/companies');
  root.Users = require('./modules/users');
  root.Roles = require('./modules/roles');
  root.Tags = require('./modules/tags');
  root.Sectors = require('./modules/sectors');
  root.Insights = require('./modules/insights');
  root.Metrics = require('./modules/metrics');
  root.Indicators = require('./modules/indicators');
  root.Settings = require('./modules/settings');
  root.Groups = require('./modules/groups');
  root.Miscellaneous = require('./modules/miscellaneous');
  root.DataFeeds = require('./modules/data-feeds');
  root.Malware = require('./modules/malware');
  root.ThreatActors = require('./modules/threat-actors');

  // Set up Immutable devtools
  require('immutable-devtools')(Immutable);

  // NOTE: For some reason everything breaks if we add Immutable to window
  // _before_ calling immutable-devtools
  root.Im = Immutable;
};



// WEBPACK FOOTER //
// ./src/app/expose-globals.js